import React from "react";
import { Box } from "@mui/material";
import CreditScoreSummary from "./common/CreditScoreSummary";
import CreditScoreTrend from "./common/CreditScoreTrend";
import CreditScoreFactors from "./common/CreditScoreFactors";
import CreditUtilizationCircle from "./common/CreditUtilizationCircle";
import CreditAccountsList from "./common/CreditAccountsList";
import CreditRecommendations from "./common/CreditRecommendations";

export default function CreditProfilePanel({ data }) {
  return (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
        gap: 2,
      }}
    >
      <CreditScoreSummary data={data.summary} />
      <CreditScoreTrend data={data.trend} />
    </Box>
    <CreditScoreFactors data={data.factors} />
    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: 2 }}>
      <CreditUtilizationCircle data={data.utilization} />
      <CreditAccountsList data={data.accounts} />
    </Box>
    <CreditRecommendations />
  </Box>

  );
}
